import { graphql } from 'relay-runtime';

export const sitesQuery = graphql`
  query SitesQuery($sitesFilter: SitesFilterInput, $skip: Boolean = false) {
    sites(sitesFilterInput: $sitesFilter, first: 100) @skip(if: $skip) {
      nodes {
        id
        summary
        name
        isActive
        targetGroups {
          id
          name
        }
        siteStandardStateCurriculums(filter: { isActive: ACTIVE }) {
          standardStateCurriculum {
            curriculum {
              targetGroups(filter: { isActive: ACTIVE }) {
                id
                name
                standardGrade {
                  id
                  name
                }
              }
            }
          }
        }
        siteTargetGroups {
          targetGroup {
            id
            name
          }
        }
        timeZone {
          id
          name
        }
        standardState {
          id
          stateStandardName
        }
      }
    }
  }
`;

export const sitesTargetGroupsQuery = graphql`
  query SitesTargetGroupsQuery($sitesFilter: SitesFilterInput, $skip: Boolean = false) {
    sites(sitesFilterInput: $sitesFilter, first: 100) @skip(if: $skip) {
      nodes {
        id
        summary
        name
        isActive
        targetGroups {
          id
          name
        }
      }
    }
  }
`;

export const sitesUsersQuery = graphql`
  query SitesUsersQuery($usersFilter: SiteUsersFilterInput, $sitesFilter: SitesFilterInput, $skip: Boolean = false) {
    sites(sitesFilterInput: $sitesFilter, first: 100) @skip(if: $skip) {
      nodes {
        id
        summary
        name
        isActive
        users(filter: $usersFilter) {
          id
          firstName
          lastName
          isActive
          email
          publicUserId
          roles {
            id
            name
          }
          sites {
            id
            name
            isActive
          }
          classes {
            id
            name
          }
          gradeLevels {
            name
            id
            isActive
            order
          }
        }
      }
    }
  }
`;

export const sitesNameIdQuery = graphql`
  query SitesNameIdQuery($sitesFilter: SitesFilterInput, $skip: Boolean = false) {
    sites(sitesFilterInput: $sitesFilter, first: 100) @skip(if: $skip) {
      nodes {
        id
        summary
        name
      }
    }
  }
`;

export const sitesUpdateSitesTargetGroups = graphql`
  mutation SitesUpdateSiteTargetGroupsMutation($input: [AddOrUpdateSiteTargetGroupsInput!]!) {
    addOrUpdateSiteTargetGroups(siteTargetGroups: $input) {
      siteTargetGroupNode {
        site {
          id
        }
        targetGroup {
          id
          name
        }
      }
    }
  }
`;

export const sitesTimezoneQuery = graphql`
  query SitesTimezoneQuery {
    allTimeZones {
      id
      name
    }
  }
`;

export const sitesUpdateSites = graphql`
  mutation SitesUpdateSiteMutation($input: [UpdateSiteInput!]!) {
    updateSite(input: $input) {
      siteNode {
        id
        timeZone {
          name
        }
      }
    }
  }
`;

export const getStandards = graphql`
  query SitesStandardsQuery {
    standardStates {
      id
      stateStandardName
    }
  }
`;

export const getSiteById = graphql`
  query SitesSiteByIdQuery($siteId: ID!, $skip: Boolean = false) {
    site(siteId: $siteId) @skip(if: $skip) {
      targetGroups {
        id
        name
      }
    }
  }
`;
